import React from 'react';
import { connect } from 'react-redux';
import CartPopup from './CartPopup';
import * as actions from '../../../actions/productData';
import { readCookie } from '../../common/Cookie';
import { generateEvent } from '../../../utils/dataGrinch';
import properties from '../../../modules/ajio-util/properties';
import { getIconStyles } from '../../../utils/common';
import { gtmEventPush, segmentEventPush } from '../../../modules/ga/GTMdatalayer';

class Cart extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isMouseInside: false,
      itemsInCart: 0,
      liveMessage: '',
      pendingAddAnnounce: false
    };
    this.mouseEnter = this.mouseEnter.bind(this);
    this.mouseExit = this.mouseExit.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
  }

  getTotalQty = minicart => {
    const entries = minicart?.entries || [];
    return entries.reduce((sum, e) => sum + (Number(e.quantity) || 0), 0);
  };

  announceNow = msg => {
    this.setState({ liveMessage: '' }, () => {
      // next frame makes it a fresh DOM change
      requestAnimationFrame(() => this.setState({ liveMessage: msg }));
    });
  };

  handleAddIntent = () => this.setState({ pendingAddAnnounce: true });

  componentDidUpdate(prevProps) {
    const prevQty = this.getTotalQty(prevProps.minicart);
    const currQty = this.getTotalQty(this.props.minicart);

    if (currQty !== prevQty) {
      // keep icon label in sync
      if (this.state.itemsInCart !== currQty) {
        this.setState({ itemsInCart: currQty });
      }

      // announce only when an add was intended AND total increased (>0)
      if (this.state.pendingAddAnnounce && currQty > prevQty && currQty > 0) {
        this.announceNow(`Added item to cart. Total items in cart is ${currQty}.`);
        this.setState({ pendingAddAnnounce: false });
      } else if (this.state.pendingAddAnnounce) {
        // reset the flag if there was a cart change but not an increase
        this.setState({ pendingAddAnnounce: false });
      }
    }
  }

  componentDidMount() {
    window.addEventListener('keydown', this.handleKeyDown);
    window.addEventListener('cart:add-intent', this.handleAddIntent);
    const currQty = this.getTotalQty(this.props.minicart);
    this.setState({ itemsInCart: currQty });
  }

  componentWillUnmount() {
    window.removeEventListener('keydown', this.handleKeyDown);
    window.removeEventListener('cart:add-intent', this.handleAddIntent);
  }

  handleKeyDown(event) {
    if (event.key === 'Escape') {
      this.setState({ isMouseInside: false });
      if (this.props.hideMinicart) {
        this.props.hideMinicart(); 
      }
    }
  }

  linkClick(link, name) {
    generateEvent({
      Event: 'HeaderClick',
      value: {
        LinkName: name,
        LinkUrl: link,
        Screen: 'Desktop'
      }
    });
    // window.location = link;

    gtmEventPush({
      event: 'buttonTap',
      event_category: 'buttonTap',
      event_action: 'Header Click',
      event_label: 'Bag'
    });

    // Segment Event PUsh
    segmentEventPush({
      event: 'Header Nav Clicked',
      event_category: 'buttonTap',
      event_action: 'Header Click',
      event_label: 'Bag',
      //active_notification:counter,
      bag_item_count: this.props.counter?.cartCount,
      component_name:'Cart',  
      screen_name:'Bag Screen'
      
    });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.hideMinicart) {
      this.setState({ isMouseInside: false });
      location.reload();
    }
  }

  mouseEnter() {
    console.log('TRACK CART ISSUE : In Cart.jS File, mouseEnter function.');
    this.props.displayMinicart();
    this.setState({ isMouseInside: true });
  }

  mouseExit() {
    this.setState({ isMouseInside: false });
  }

  render() {
    let showCartPopup = this.props.showCart;
    let { cartCount: cartCounter = 0 } = this.props.counter;
    const {
      metaData: {
        sis = false,
        current: { headerIconColor, buttonPatchColor } = {},
        name: storeName = ''
      } = {},
      newDesignLuxe,
      isStreetStore
    } = this.props;
    let cartCount = cartCounter;
    const cookie = readCookie('nq');
    if (cookie) {
      const cookieList = cookie.split(':');
      if (cookieList.length) {
        cartCount = cookieList[0].split('=')[1];
      }
    }
    const iconStyles = getIconStyles({
      headerIconColor,
      buttonPatchColor
    });
    const { itemsInCart, liveMessage } = this.state;
    // console.log('items in cart', itemsInCart, 'minicart', this.props.minicart);

    return (
      <div
        className="popup-blk cart-blk"
        onMouseEnter={this.mouseEnter}
        onMouseLeave={this.mouseExit}
        onFocus={this.mouseEnter}
        onBlur={this.mouseExit}
      >
        <div
          role="alert"
          aria-live="assertive"
          aria-atomic="true"
          tabIndex={-1}
          style={{
            position: 'absolute',
            width: 1,
            height: 1,
            margin: -1,
            border: 0,
            padding: 0,
            clip: 'rect(0 0 0 0)',
            overflow: 'hidden',
            whiteSpace: 'nowrap'
          }}
        >
          {liveMessage}
        </div>
        <a
          href={
            sis && !newDesignLuxe && !isStreetStore
              ? `${properties.getProperty('parentUrl')}/cart`
              : '/cart'
          }
          onClick={() => {
            this.linkClick('/cart', 'Bag');
          }}  
          aria-label={itemsInCart > 0 ? `Cart with ${itemsInCart} ${itemsInCart === 1 ? "item" : "items"}` : 'Cart'}
          tabIndex={0}
          {...(this.getTotalQty(this.props.minicart) <=0 && {'aria-describedby':'cart-tooltip-text'})}
        >
          <div
            className={`ic-cart ${cartCount > 0 ? 'count' : ''}`}
            style={isStreetStore && storeName === 'street' ? { color: 'white' } : iconStyles}
            tabIndex={-1}
            aria-hidden="true"
          >
            {cartCount > 0 && <span className="cart-count">{cartCount}</span>}
          </div>
        </a>
        {this.state.isMouseInside || showCartPopup ? (
          <CartPopup
            setItemsInCart={this.setItemsInCart}
            newDesignLuxe={newDesignLuxe}
            isStreetStore={isStreetStore}
          />
        ) : null}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    showCart: state.popup.showCartPopup,
    hideMinicart: state.popup.hideMinicart,
    counter: state.counter,
    metaData: state.metaData,
    minicart: state.minicart.Minicart
  };
};
const mapDispatchToProps = dispatch => {
  return {
    displayMinicart: () => dispatch(actions.displayMinicart())
  };
};
export default Cart = connect(mapStateToProps, mapDispatchToProps)(Cart);
